import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import dayjs from 'dayjs';
import { fetchCalendarMeetings, fetchCalendarMeetingsToday } from "../../redux/client/calendarSlice";

const MeetingNotification = () => {
  const [showNotification, setShowNotification] = useState(true);
  const dispatch = useDispatch();

  const { clientData } = useSelector((state) => state.client);
  const { meetings,todayMeetings } = useSelector((state) => state.calendar);

  // console.log('todayMeetings',todayMeetings,meetings);
  
  const [upcomingMeetings, setUpcomingMeetings] = useState([]);

  useEffect(() => {
    const today = dayjs().format('YYYY-MM-DD');
    // if (clientData?.advisor_id) {
    //   dispatch(fetchCalendarMeetings(clientData.advisor_id));
    // }

    const interval = setInterval(() => {
      if (clientData?.advisor_id) {
        dispatch(fetchCalendarMeetingsToday({
          advisorId: clientData.advisor_id,
          today: dayjs().format('YYYY-MM-DD'),
        }))
        
      }
    }, 60 * 1000);

    return () => clearInterval(interval);
  }, [clientData?.advisor_id, dispatch]);

  useEffect(() => {
    if (!Array.isArray(meetings)) {
      setUpcomingMeetings([]);
      setShowNotification(false);
      return;
    }
  
    const now = new Date();
    const tenMinutesLater = new Date(now.getTime() + 10 * 60000);
  
    const filtered = meetings.filter((meeting) => {
      const meetingTime = new Date(meeting.startTime);
      return meetingTime >= now && meetingTime <= tenMinutesLater;
    });
  
    setUpcomingMeetings(filtered);
    setShowNotification(filtered.length > 0);
  }, [meetings]);
  

  if (!showNotification || upcomingMeetings.length === 0) return null;

  return (
    <div
      className="alert alert-warning alert-dismissible fade show fixed-bottom m-3 shadow"
      role="alert"
    >
      <div>
        <strong>🔔 Upcoming Meetings:</strong>{" "}
        {upcomingMeetings.map((meet, index) => (
          <span key={index} className="mx-2">
            <strong>{meet.title}</strong> with{" "}
            <strong>{meet.clientName}</strong> at{" "}
            <strong>{format(new Date(meet.startTime), "hh:mm a")}</strong>
          </span>
        ))}
      </div>
      <button
        type="button"
        className="btn-close"
        aria-label="Close"
        onClick={() => setShowNotification(false)}
      ></button>
    </div>
  );
};

export default MeetingNotification;
